module.exports = __webpack_public_path__ + "static/media/aboutus_balls.4e0f584f.svg";